module.exports = __webpack_public_path__ + "img/12.fcd5f15d.jpg";